<ng-container>
  <div
    [hidden]="isFileUploaded"
    class="drop-area"
    appDragDrop
    (onFileDropped)="onFileDropped($event)"
    (drop)="drop($event)"
    (dragover)="allowDrop($event)"
  >
    <div class="drop-icon">
      <i class="fas fa-file-import"></i>
    </div>

    <input
      type="file"
      #fileDropRef
      id="fileDropRef"
      accept="application/pdf"
      (change)="imageChange($event)"
    />

    <div class="drop-text">{{ "DRAG_AND_DROP_FILE_HERE" | translate }}</div>

    <div class="drop-text">{{ "OR" | translate }}</div>

    <label class="drop-text" for="fileDropRef">{{
      "BROWSE_FOR_FILE" | translate
    }}</label>

    <div class="drop-text">File Supported: PDF</div>
  </div>
  <div class="drop-area" id="preview" #preview [hidden]="!isFileUploaded"></div>
</ng-container>
